exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3Smkp{max-width:320px}._1EnsW{margin:60px 30px 0 0;box-shadow:0 0 2px 0 #0000001f,0 2px 2px 0 rgba(0,0,0,.24);border-radius:4px;width:100%;padding:26px;background:#fff}._1Z4o6{font-size:16px;line-height:150%;color:#767676}._1vES3{color:#2d2d2d;display:block;width:100%}@media screen and (max-width:768px){._1EnsW{margin:60px 0 0}}._3S-4R{height:20px;width:20px;color:#767676}", ""]);

// exports
exports.locals = {
	"helpPanelContainer": "_3Smkp",
	"helpPanel": "_1EnsW",
	"helpPanelText": "_1Z4o6",
	"helpPanelTextTitle": "_1vES3",
	"iconSize": "_3S-4R"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/ListPlaceTips/ListPlaceTips.css
// module id = 2543
// module chunks = 15